import { Col, Row } from "./Grid";
import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const Styles = theme => ({
  pricingContainer: {
    width: "100%",
    color: theme.colours.content.fontColor,
    fontSize: theme.text.fontSize,
    textAlign: theme.text.textAlign,
    "& h1": {
      textAlign: "center",
      fontSize: "2rem",
      margin: 0,
      fontWeight: 100
    },
    " & ul": {
      listStyleType: "none"
    },
    " & ul li:first-letter": {
      color: theme.colours.palette.green,
      float: "left",
      position: "relative"
    }
  },
  notMobile: {
    "@media (max-width: 823px)": {
      display: "none"
    }
  },
  mobile: {
    "& h1": {
      fontSize: "1.8rem"
    },
    "@media (min-width: 823px)": {
      display: "none"
    }
  }
});

const PricingContainer = ({ classes, children }) => (
  <div className={classes.pricingContainer}>
    <div className={classes.notMobile}>
      <Row around>{children}</Row>
    </div>
    <div className={classes.mobile}>
      <Col center>{children}</Col>
    </div>
  </div>
);

PricingContainer.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object
};

export default injectSheet(Styles)(PricingContainer);



// WEBPACK FOOTER //
// ./src/components/PricingContainer.jsx